const initialState = {
    pending: false,
    weatherDataReports: [],
    error: null,
    filters: {dateFrom: '', dateTo: '', numberOfDaysInPast: '', measurementsPeriodAggregation: '', weatherStationId: ''}
}

const weatherDataReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_WEATHER_DATA_REPORTS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_WEATHER_DATA_REPORTS_SUCCESS':
            return {
                ...state,
                pending: false,
                weatherDataReports: action.weatherDataReports,
            }
        case 'GET_WEATHER_DATA_REPORTS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case 'SET_WEATHER_DATA_REPORTS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        default:
            return state;
    }
}

export default weatherDataReportsReducer;
